/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { requestGetSpaceById } from "services/settings/spaceAdmin/aboutSpaceAdmin";
import { configSessionStorage } from "services/storage/config";
import useSpaceSelected from "views/Configuracion/SettingsSpaceAdmin/utils/hooks/useSpaceSelected";

const usePreloadSpace = ({
	loadingRequest, isUpdate
}) => {
    const navigate = useNavigate();
    const spaceSelected = useSpaceSelected();
	useEffect(() => {
		preloadSpace();
	}, []);
	async function preloadSpace() {
        if (!isUpdate) return;
        const spaceId = getSpaceId();
        if (!spaceId) {
            navigate(ABSOLUTE_PATHS.SETTINGS_SPACE_ADMIN);
            return;
        } 
        loadingRequest.show();
        const space = await requestGetSpaceById(spaceId);
        loadingRequest.hide();
        spaceSelected.update(space);
    }
    function getSpaceId() {
        return configSessionStorage.spaceAdmin.spaceId.get();
    }
	return spaceSelected;
}
	
export default usePreloadSpace;